<!--
Author: TangChen
Date: 2019-02-27
Desc: 基金风险过滤，为公共组件
 -->
<template>
    <div class="comp-fund-risk-filter comp">
        <div
            v-if="$cache.getUser().professionflag === '0' && qryall"
            :class="
                quickBuy
                    ? 'risk-filter-quickbuy'
                    : changefund
                    ? 'risk-filter-changefund'
                    : 'risk-filter-text'
            "
        >
            <i v-if="!quickBuy && !changefund" class="el-icon-warning" aria-hidden="true" />
            <span>
                {{ warnContent() }}
                <span
                    class="like-a"
                    :class="quickBuy ? 'quick-buy-text' : ''"
                    v-on:click.prevent="showQryMsg"
                >
                    {{ quickBuy ? "了解相关法规" : changefund ? "了解相关法规 >>" : "前往了解" }}
                </span>
            </span>
        </div>
        <el-dialog
            title="产品展示适当性说明"
            :visible.sync="visiblePrompt"
            class="prop info-tips"
            width="880px"
        >
            <div class="investor-tips">
                <div class="tit-warn">
                    <i class="el-alert__icon el-icon-warning is-big" aria-hidden="true" />
                    <span class="tit-warn-text">
                        根据
                        <span>《证监会适当性管理办法规定》</span>
                    </span>
                </div>
                <p class="tit">
                    尊敬的投资者您好！根据证监会《证券期货投资者适当性管理办法》的以下相关规定，产品列表已根据您的风险等级作筛选展示：
                </p>
                <div class="investor-info">
                    <p class="list-inv-info">
                        <span>
                            第十八条
                            经营机构应当根据产品或者服务的不同风险等级，对其适合销售产品或者提供服务的投资者类型作出判断，
                        </span>
                        <span>
                            根据投资者的不同分类，对其适合购买的产品或者接受的服务作出判断。
                        </span>
                    </p>
                    <p class="list-inv-info">
                        <span>
                            第十九条
                            经营机构告知投资者不适合购买相关产品或者接受相关服务后，投资者主动要求购买风险等级高于其风险承受能力的产品或者接受相关服务的，
                        </span>
                        <span>
                            经营机构在确认其不属于风险承受能力最低类别的投资者后，应当就产品或者服务风险高于其承受能力进行特别的书面风险警示，
                        </span>
                        <span>投资者仍坚持购买的，可以向其销售相关产品或者提供相关服务。</span>
                    </p>
                    <p class="list-inv-info">
                        <span>
                            第二十条
                            经营机构向普通投资者销售高风险产品或者提供相关服务，应当履行特别的注意义务，包括制定专门的工作程序，
                        </span>
                        <span>
                            追加了解相关信息，告知特别的风险点，给予普通投资者更多的考虑时间，或者增加回访频次等。
                        </span>
                    </p>
                    <p class="list-inv-info">
                        <span>
                            第二十一条
                            经营机构应当根据投资者和产品或者服务的信息变化情况，主动调整投资者分类、产品或者服务分级以及适当性匹配意见，并告知投资者上述情况。
                        </span>
                    </p>
                    <p class="list-inv-info">
                        <span>第二十二条 禁止经营机构进行下列销售产品或者提供服务的活动：</span>
                    </p>
                    <p class="list-inv-info">
                        <span>(一)向不符合准入要求的投资者销售产品或者提供服务；</span>
                    </p>
                    <p class="list-inv-info">
                        <span>
                            (二)向投资者就不确定事项提供确定性的判断，或者告知投资者有可能使其误认为具有确定性的意见；
                        </span>
                    </p>
                    <p class="list-inv-info">
                        <span>
                            (三)向普通投资者主动推介风险等级高于其风险承受能力的产品或者服务；
                        </span>
                    </p>
                    <p class="list-inv-info">
                        <span>(四)向普通投资者主动推介不符合其投资目标的产品或者服务；</span>
                    </p>
                    <p class="list-inv-info">
                        <span>
                            (五)向风险承受能力最低类别的投资者销售或者提供风险等级高于其风险承受能力的产品或者服务；
                        </span>
                    </p>
                    <p class="list-inv-info">
                        <span>(六)其他违背适当性要求，损害投资者合法权益的行为。</span>
                    </p>
                    <p class="list" v-html="qryOther" />
                </div>
            </div>
            <div class="dialog-footer">
                <el-button v-on:click="visiblePrompt = false">取 消</el-button>
                <el-button type="primary" v-on:click="qryChange">
                    我已阅知风险，{{ qryall === "0" ? "申请恢复过滤展示" : "申请展示全部产品" }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "FundRiskFilter",
    props: {
        qryall: {
            type: String,
            required: true
        }, // 适当性过滤字段
        changefund: {
            type: Boolean,
            default: false
        }, // 基金转换
        quickBuy: {
            type: Boolean,
            default: false
        } // 快速购买
    },
    data() {
        return {
            visiblePrompt: false, // 适当性过滤弹窗
            qryOther: "", // 协议增加内容
            quickBuyText:
                "风险提示：基金过往业绩不预示未来表现，产品列表已根据您的风险等级做筛选调整。您已主动要求查看高于您风险等级的产品。", // 快速购买提示
            changeFundText:
                "根据证监会适当性管理办法，目标基金列表已根据您的风险等级做筛选调整。您已主动要求查看高于您风险等级的产品。" // 基金转换提示
        };
    },
    mounted() {},
    methods: {
        // 查询风险过滤协议补充内容
        showQryMsg() {
            this.$util.getProtocol("3").then((res) => {
                if (res.length) {
                    this.qryOther = res[0].content;
                }
                this.visiblePrompt = true;
            });
        },
        // 提示文案
        warnContent() {
            if (this.quickBuy && this.qryall == "0") {
                return this.quickBuyText;
            } else if (this.changefund) {
                return this.qryall == "0"
                    ? this.changeFundText
                    : "根据证监会适当性管理办法，目标基金列表已根据您的风险等级做筛选调整。";
            }
            return this.$util.riskFilter(this.qryall);
        },
        // 改变风险过滤规则
        qryChange() {
            this.visiblePrompt = false;
            this.$emit("qry-change", this.qryall === "0" ? "1" : "0");
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
$text-color-inv-info: #666666;
.investor-info {
    .list-inv-info {
        color: $text-color-inv-info;
        line-height: 24px;
        text-align: justify;
        span {
            color: $text-color-inv-info;
        }
    }
}
.comp-fund-risk-filter {
    .risk-filter-quickbuy {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 14px 0;
        background: #f9f9f9;
        color: #999999;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
    }
    .quick-buy-text {
        color: #666666 !important;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        border-bottom: 1px solid #666666;
    }
    .risk-filter-changefund {
        font-size: 14px;
        color: #e60012;
        padding-left: 170px;
        padding-right: 330px;
        margin-bottom: 20px;
    }
}
</style>
